var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadFilePdf = function SvgDownloadFilePdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DCD1B9",
    fillRule: "evenodd",
    d: "m26.286 10.288-8.002-8.002H8.114a2.4 2.4 0 0 0-2.4 2.4v22.629a2.4 2.4 0 0 0 2.4 2.4h15.772a2.4 2.4 0 0 0 2.4-2.4z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9A476",
    d: "M18.284 10.286v-8l8 8zM20.375 22.637h-1.008V17h3.594v.852h-2.586v1.664h2.363v.82h-2.363zM13.828 17h2.059c1.683 0 2.68 1.02 2.68 2.805s-.993 2.832-2.68 2.832h-2.059zm1.008.852v3.933h.945c1.133 0 1.758-.691 1.758-1.976 0-1.262-.633-1.957-1.758-1.957zM9 17h2.191c1.121 0 1.899.762 1.899 1.887s-.8 1.886-1.942 1.886h-1.14v1.864H9zm1.008.824v2.137h.914c.723 0 1.144-.39 1.144-1.074 0-.676-.418-1.063-1.14-1.063z"
  })));
};
export default SvgDownloadFilePdf;